"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-shield.tsx
var Shield = function Shield(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M11.5833 22.5833L21 13.1667L18.625 10.7917L11.5833 17.8333L8.08333 14.3333L5.70833 16.7083L11.5833 22.5833ZM13.3333 33.3333C9.47222 32.3611 6.28472 30.1458 3.77083 26.6875C1.25694 23.2292 0 19.3889 0 15.1667V5L13.3333 0L26.6667 5V15.1667C26.6667 19.3889 25.4097 23.2292 22.8958 26.6875C20.3819 30.1458 17.1944 32.3611 13.3333 33.3333ZM13.3333 29.8333C16.2222 28.9167 18.6111 27.0833 20.5 24.3333C22.3889 21.5833 23.3333 18.5278 23.3333 15.1667V7.29167L13.3333 3.54167L3.33333 7.29167V15.1667C3.33333 18.5278 4.27778 21.5833 6.16667 24.3333C8.05556 27.0833 10.4444 28.9167 13.3333 29.8333Z",
    fill: "currentColor"
  }));
};

var _default = Shield;
exports.default = _default;